// Every colour in the game. There are not many, on purpose: the sprites and
// the two ground materials carry the look, and everything the code draws is
// either a nameplate, a bar or a panel.

export const PALETTE = {
  /** Terrain drawn by code rather than by a material. */
  rock: "#3b3a36",
  grassFallback: "#4f7d33",
  floorFallback: "#6b4a2c",
  treeTrunk: "#5b4028",
  tree: "#2a5225",
  treeTop: "#3d7333",
  path: "#a89066",
  pathEdge: "#8d7550",
  wall: "#6b5138",
  wallTop: "#8a6a4a",
  door: "#3a2a1c",

  /** Panels, plates and the HUD. */
  ink: "#14161a",
  void: "#000000",
  shadow: "rgba(0, 0, 0, 0.55)",
  panel: "rgba(16, 18, 22, 0.82)",
  edge: "#3d444f",
  text: "#e8e6e1",
  dim: "#9aa0a8",

  /** Bars and sparks. */
  hp: "#d8443a",
  hpBack: "#3a1f1e",
  gold: "#e7b93c",
  heal: "#63c66b",
  enemyDeath: "#8fd36a",
  slash: "#ffffff",
  hurt: "#ff6a5a",
} as const;
